import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedComponentsModule } from '../../shared/shared-components.module';

import { SearchDetailsComponent } from './search-details.component';
import { LocationResultCardComponent } from './components/location-result-card/location-result-card.component';
import { OtherDoctorCardComponent } from './components/other-doctor-card/other-doctor-card.component';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule
  ],
  declarations: [
    SearchDetailsComponent,
    LocationResultCardComponent,
    OtherDoctorCardComponent
  ],
  exports: [
    SearchDetailsComponent,
  ]
})
export class SearchDetailsModule { }
